/**
 * @typedef {Object} OrchestrationEvent
 * @property {string} eventId
 * @property {string} aggregateType 'competition' | 'match'
 * @property {string} aggregateId
 * @property {string} eventType
 * @property {number} eventVersion
 * @property {string} causationId commandId
 * @property {string} [correlationId]
 * @property {string | null} actorUid
 * @property {Record<string, unknown>} payload
 * @property {number} occurredAtMs
 */

export const ORCHESTRATION_EVENT_TYPES = {
  MATCH_CREATED: "MatchCreated",
  MATCH_STARTED: "MatchStarted",
  MATCH_PAUSED: "MatchPaused",
  MATCH_RESUMED: "MatchResumed",
  MATCH_COMPLETED: "MatchCompleted",
  ALLOCATIONS_RELEASED: "AllocationsReleased",
  MANAGER_LEASE_TRANSFERRED: "ManagerLeaseTransferred",
};

export function newEventId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `ev_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}
